import tripService, { ReceiptSummaryResponse } from '../../services/trip/tripService';
import { ReceiptActions } from '../../types/receipt.store.type';
import { fetchTripError } from './trip.actions';

export const fetchReceiptSummary = (reservationId: string) => async (dispatch: any) => {
    try {
        dispatch(fetchReceiptBegin());
        const receipt = await tripService.getReceiptSummary(reservationId);
        dispatch(fetchReceiptSuccess(receipt));
    } catch (e) {
        if (e.status === 403 && isThirdPartyError(e.message)) {
            dispatch(fetchReceiptError(e));
        } else {
            dispatch(fetchTripError(e));
        }
    }
};

function fetchReceiptBegin() {
    return { type: ReceiptActions.RECEIPT_FETCH_BEGIN };
}

function fetchReceiptSuccess(receipt: ReceiptSummaryResponse) {
    return { type: ReceiptActions.RECEIPT_FETCH_SUCCESS, payload: receipt };
}

function fetchReceiptError(error: Error) {
    return { type: ReceiptActions.RECEIPT_FETCH_ERROR, payload: error };
}

function isThirdPartyError(message: string): boolean {
    return message.includes('THIRD_PARTY_CHANNEL_BOOKING');
}
